import { connect } from 'react-redux';
import { logoUploadStatusSelector } from '../../../redux/logo-editing/logo-editing.selectors';
import { LogoUploadProgressBarComponent } from './logo-upload-progress-bar';
export const LogoUploadProgressBar = connect(logoUploadStatusSelector)(LogoUploadProgressBarComponent);